import React, { Component } from 'react';
import classNames from 'classnames';
import AntDatePicker from 'antd/lib/date-picker';
import { DatePickerProps as AntDatePickerProps } from 'antd/lib/date-picker/interface';
import { ScrollCustomStyles } from 'components/ScrollCustomStyles/ScrollCustomStyles';
import { ThemeContext } from 'app-themes';

import styles from './DatePicker.module.scss';
import { DATE_FORMAT, DATE_TIME_FORMAT } from 'app-constants';

interface DatePickerProps extends AntDatePickerProps {
	dropdownClassName?: string;
}

class DatePicker extends Component<DatePickerProps> {
	static contextType = ThemeContext;
	render() {
		const { dropdownClassName, showTime, ...restProps } = this.props;
		const theme = this.context;
		return (
			<ScrollCustomStyles isDatepicker>
				<AntDatePicker
					{...restProps}
					format={showTime ? DATE_TIME_FORMAT : DATE_FORMAT}
					showTime={showTime}
					className={classNames(styles.datePicker, {
						[styles[`datePicker-${theme}`]]: theme !== '',
					})}
					dropdownClassName={classNames(styles.dropdownDatePicker, dropdownClassName, {
						[styles[`dropdownDatePicker-${theme}`]]: theme !== '',
					})}
				/>
			</ScrollCustomStyles>
		);
	}
}

export default DatePicker;
